import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { global } from '../../shared/global';

@Injectable({
  providedIn: 'root'
})
export class StudentregistrationService {

  constructor(private http: HttpClient) { }
  public httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  fillBoard(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillStudentBoard', data, global.httpOptions);
  }
  fillState(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillState', data, global.httpOptions);
  }
  fillCity(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillCity', data, global.httpOptions);
  }
  fillSchoolCategory(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillSchoolCategory', data, global.httpOptions);
  }
  fillSchoolArea(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillSchoolArea', data, global.httpOptions);
  }
  fillSchoolName(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillSchoolName', data, global.httpOptions);
  }
  fillStandard(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillSchoolStandard', data, global.httpOptions);
  }
  saveStudent(data) {
    return this.http.post(global.baseAPIUrl + 'StudentRegistration/saveStudent', data, global.httpOptions);
  }
  getSchooltByHashcode(data) {
    return this.http.post(global.baseAPIUrl + 'StudentRegistration/getSchooltByHashcode', data, global.httpOptions);
  }
  getStudentByHashcode(data) {
    return this.http.post(global.baseAPIUrl + 'StudentRegistration/getStudentByHashcode', data, global.httpOptions);
  }
  sendCaptcha(data) {
    return this.http.post(global.baseAPIUrl + 'StudentRegistration/verifyCaptcha', data, global.httpOptions);
  }
}
